import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { SarlaftComplaintsProps } from './props';
import { useSarlaftComplaints } from './hook';

export const SarlaftClaims = (props: SarlaftComplaintsProps) => {
    const { formik } = useSarlaftComplaints(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Reclamaciones
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de reclamo"
                    name="dateComplaint"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.dateComplaint}
                    errors={formik.errors.dateComplaint?.toString()}
                    value={
                        formik.values.dateComplaint
                            ? dayjs(formik.values.dateComplaint)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'dateComplaint',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Ramo"
                    name="bouquet"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.bouquet}
                    errors={formik.errors.bouquet}
                    value={formik.values.bouquet}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Compañia"
                    name="company"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.company}
                    errors={formik.errors.company}
                    value={formik.values.company}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Valor"
                    name="value"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.value}
                    errors={formik.errors.value}
                    value={formik.values.value}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Reclamación"
                    name="complaint"
                    rows={6}
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.complaint}
                    errors={formik.errors.complaint}
                    value={formik.values.complaint}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={16}>
                <FieldText
                    label="Indemnización"
                    name="compensation"
                    rows={6}
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.compensation}
                    errors={formik.errors.compensation}
                    value={formik.values.compensation}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
